/**
 * Tag schemas — Tier 1 free-form labels per client/engagement.
 *
 * Canopy/ClickUp both have tags as a primary layer. Missing here until now.
 */

import { z } from 'zod';
import { idSchema, iso8601Schema, pageInput } from './common';

export const tagScopeSchema = z.enum([
  'CLIENT',
  'ENGAGEMENT',
  'COMPLIANCE_CLIENT',
  'COMPLIANCE_ITEM',
  'TASK',
  'NOTE',
]);

export const tagOutputSchema = z.object({
  id: idSchema,
  name: z.string().min(1).max(40).regex(/^[a-z0-9-]+$/, 'lowercase letters, digits, hyphens only'),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  description: z.string().max(200).nullable(),
  usageCount: z.number().int().nonnegative().default(0),
  createdAt: iso8601Schema,
});
export type TagOutput = z.infer<typeof tagOutputSchema>;

export const createTagInputSchema = z.object({
  name: z.string().min(1).max(40).regex(/^[a-z0-9-]+$/),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
  description: z.string().max(200).nullable().optional(),
});
export type CreateTagInput = z.infer<typeof createTagInputSchema>;

export const updateTagInputSchema = createTagInputSchema.partial();
export type UpdateTagInput = z.infer<typeof updateTagInputSchema>;

export const tagEntityInputSchema = z.object({
  tagId: idSchema,
  entityType: tagScopeSchema,
  entityId: idSchema,
});

export const untagEntityInputSchema = z.object({
  tagId: idSchema,
  entityType: tagScopeSchema,
  entityId: idSchema,
});

export const listTagsInputSchema = pageInput.extend({
  search: z.string().optional(),
});
export type ListTagsInput = z.infer<typeof listTagsInputSchema>;